import { RequirementsEnum } from './notify-requirements-enum';

enum MainMenuNameEnum {
  USER_MANAGEMENT = 'จัดการสิทธ์การใช้งาน',
  ACCESS_RIGHTS = 'จัดการบัญชีผู้ใช้งานระบบ',
  DATA_MANAGEMENT = 'การจัดการข้อมูลพื้นฐาน',
  MATERIAL_MANAGEMENT = 'บริหารจัดการวัสดุ',
  FUEL_ASSET_MANAGEMENT = 'บริหารจัดการครุภัณฑ์และรถราชการฯ',
  EQUIPMENT_MANAGEMENT = 'การบริหารจัดการครุภัณฑ์',
  VEHICLE_AND_FUEL_MANAGEMENT = 'บริหารจัดการครุภัณฑ์และรถราชการฯ',
  LAND_AND_BUILDING_MANAGEMENT = 'บริหารจัดการที่ดิน อาคารและสิ่งปลูกสร้าง',
  DATA_CORRECTION_REQUEST = 'แบบแจ้งขอแก้ไขข้อมูล',
}

enum SubMenuNameEnum {
  USER_MANAGEMENT = 'สิทธิ์การเข้าถึงเมนู',
  USER_ROLE_GROUPS = 'กลุ่มสิทธิ์การใช้งาน',

  ACCESS_RIGHTS = 'จัดการบัญชีผู้ใช้งานระบบ',

  AGENCY_DATA_MANAGEMENT = 'หน่วยงาน',
  ASSET_SOURCE_DATA_MANAGEMENT = ' แหล่งของเงิน',
  PROJECT_ACTIVITIES_DATA_MANAGEMENT = 'โครงการ/กิจกรรม',
  MATERIAL_DATA_MANAGEMENT = 'วัสดุ',
  EQUIPMENT_DATA_MANAGEMENT = 'ครุภัณฑ์',
  VEHICLE_AND_FUEL_EQUIPMENT_DATA_MANAGEMENT = 'รถ (กรมการขนส่งทางบก)',
  LAND_AND_BUILDING_DATA_MANAGEMENT = 'ที่ดินและสิ่งปลูกสร้าง',

  MATERIAL_ALL_REGISTER = 'ทะเบียนคุมวัสดุทั้งกรม',
  MATERIAL_REGISTER = 'ทะเบียนคุมวัสดุ',
  NOTIFY_REQUIREMENTS = 'เเจ้งความต้องการ',
  MATERIAL_INSPECTION = 'ตรวจรับวัสดุ',
  MATERIAL_REQUISITION = 'เบิกวัสดุ',
  ANNUAL_INVENTORY_CHECK = 'ตรวจนับประจำปี',
  DASHBOARD = 'Dashboard',

  EQUIPMENT_REGISTER = 'ทะเบียนคุมครุภัณฑ์',
  ASSET_RECORD_INSPECTION = 'บันทึกรายการสินทรัพย์',
  EQUIPMENT_REQUISITION = 'การเบิกครุภัณฑ์',
  EQUIPMENT_LOAN_RETURN = 'การยืม-คืนครุภัณฑ์',
  RETURN_WAREHOUSE = 'คลังครุภัณฑ์ (ส่งคืน)',
  MONTHLY_REPORT_HISTORY = 'ประวัติการออกรายงานประจำเดือน',
  VEHICLE_BOOKING_CALENDAR = 'การขออนุญาตใช้รถราชการ',
  REPORTS = 'รายงาน',

  LAND_REGISTRY = 'ทะเบียนคุมที่ดิน',
  BUILDING_REGISTRY = 'ทะเบียนคุมอาคารและสิ่งปลูกสร้าง',
  ASSET_RECORD = 'บันทึกรายการสินทรัพย์ ',
  BORROW_RETURN_BUILDING = 'การยืม-คืน อาคารและสิ่งปลูกสร้าง',
  BUILDING_WAREHOUSE = 'คลังอาคารและสิ่งปลูกสร้าง (ส่งคืน)',
  ANNUAL_AUDIT = 'ตรวจนับประจำปี',

  DATA_CORRECTION_RECORD = 'บันทึกแบบขอเเจ้งแก้ไขข้อมูล',
}

export enum AssetRequirementsEnum {
  INFORMATION = 'ข้อมูล',
  EQUIPMENT_HISTORY = 'ประวัติครุภัณฑ์ (ยืม-คืน)',
  VEHICLE_USAGE_HISTORY = 'ประวัติการใช้รถราชการ',
  MAINTENANCE = 'การซ่อมแซมและบำรุงรักษา',
  FUEL_USAGE = 'การใช้น้ำมันเชื้อเพลิง',
  TIRE_USAGE_STATS = 'สถิติการใช้ยาง',
  BATTERY_USAGE_STATS = 'สถิติการใช้แบตเตอรี่',
  ACCIDENT_REPORTS = 'รายงานอุบัติเหตุ',
  VEHICLE_INSPECTION = 'การตรวจสภาพและต่อภาษี',
  INSURANCE_AND_ACT = 'การต่อ พรบ. และจัดทำประกันภัยภาคสมัครใจ',
  POLLUTION_CHECK = 'การตรวจวัดมลพิษทางอากาศและระดับเสียงจากรถราชการ',
}

enum BuildingRequirementsEnum {
  PROCUREMENT = 'การจัดซื้อจัดจ้าง',
  DONATION = 'การรับบริจาค',
  TRANSFER = 'การรับโอน',
  DISCOVERY = 'การสำรวจพบ',
  PENDING_TRANSFER = 'สินทรัพย์รอโอน',
}

export enum BorrowEnum {
  INTERNAL_EXTERNAL_BORROW = 'ยืมใช้ภายในหน่วยงาน/ใช้นอกสถานที่',
  INTERAGENCY_BORROW = 'ยืมระหว่างหน่วยงานของรัฐ',
  FARMER_GROUP_BORROW = 'กลุ่มเกษตรกร/สหกรณ์ยืม',
}

export enum SellReturnBuildingEnum {
  INVENTORY_LIST = 'รายการคลังครุภัณฑ์',
  RETURN_LIST = 'รายการส่งคืน',
  WITHDRAWAL_LIST = 'รายการเบิก',
  DISPOSAL_LIST = 'รายการจำหน่าย',
}

export enum HistoryBuildingEnum {
  INFORMATION = 'ข้อมูล',
  ROOM_REGISTRY = 'ทะเบียนคุมห้อง',
  BUILDING_HISTORY = 'ประวัติอาคารและสิ่งปลูกสร้าง (ยืม-คืน)',
  MAINTENANCE = 'การซ่อมแซมและบำรุงรักษา',
}

export enum BuildingMethodEnum {
  PROCUREMENT = 'การจัดซื้อจัดจ้าง',
  DONATION = 'การรับบริจาค',
  TRANSFER = 'การรับโอน',
  DISCOVERY = 'การสำรวจพบ',
  PENDING_TRANSFER = 'สินทรัพย์รอโอน',
}

export enum BuildingBorrowEnum {
  INTERNAL_EXTERNAL_BORROW = 'ยืมใช้ภายในหน่วยงาน/ใช้นอกสถานที่',
  INTERAGENCY_BORROW = 'ยืมระหว่างหน่วยงานของรัฐ',
  FARMER_GROUP_BORROW = 'กลุ่มเกษตรกร/สหกรณ์ยืม',
}

export enum BuildingReturnEnum {
  INVENTORY_LIST = 'รายการคลังอาคารและสิ่งปลูกสร้าง',
  RETURN_LIST = 'รายการส่งคืน',
  WITHDRAWAL_LIST = 'รายการการเบิก',
  DISPOSAL_LIST = 'รายการจำหน่าย',
}

export type SubMenuItem = {
  sub_menu_id: string;
  sub_menu_name: string;
  visibility_id?: string;
  is_view: boolean;
  child_sub_menus?: ChildSubMenu[];
};

export type MainMenu = {
  main_menu_id: string;
  main_menu_name: string;
  menus: SubMenuItem[];
  child_sub_menus?: ChildSubMenu[];
};

export type ChildSubMenu = {
  mapping_child_sub_id?: number;
  sub_menu_id?: number;
  child_sub_menu_id: number;
  child_sub_menu_name?: string;
  is_view: boolean;
};

const mainMenuMap: Record<string, string[]> = {
  USER_MANAGEMENT: ['USER_MANAGEMENT', 'USER_ROLE_GROUPS'],
  ACCESS_RIGHTS: ['ACCESS_RIGHTS'],
  DATA_MANAGEMENT: [
    'AGENCY_DATA_MANAGEMENT',
    'ASSET_SOURCE_DATA_MANAGEMENT',
    'PROJECT_ACTIVITIES_DATA_MANAGEMENT',
    'MATERIAL_DATA_MANAGEMENT',
    'EQUIPMENT_DATA_MANAGEMENT',
    'VEHICLE_AND_FUEL_EQUIPMENT_DATA_MANAGEMENT',
    'LAND_AND_BUILDING_DATA_MANAGEMENT',
  ],
  MATERIAL_MANAGEMENT: [
    'MATERIAL_REGISTER',
    'NOTIFY_REQUIREMENTS',
    'MATERIAL_INSPECTION',
    'MATERIAL_REQUISITION',
    'ANNUAL_INVENTORY_CHECK',
    'DASHBOARD',
    'REPORTS',
  ],
  VEHICLE_AND_FUEL_MANAGEMENT: [
    'EQUIPMENT_REGISTER',
    'ASSET_RECORD_INSPECTION',
    'EQUIPMENT_REQUISITION',
    'EQUIPMENT_LOAN_RETURN',
    'RETURN_WAREHOUSE',
    'VEHICLE_BOOKING_CALENDAR',
    'ANNUAL_INVENTORY_CHECK',
    'DASHBOARD',
    'REPORTS',
  ],
  LAND_AND_BUILDING_MANAGEMENT: [
    'LAND_REGISTRY',
    'BUILDING_REGISTRY',
    'ASSET_RECORD',
    'BORROW_RETURN_BUILDING',
    'BUILDING_WAREHOUSE',
    'ANNUAL_AUDIT',
    'DASHBOARD',
    'REPORTS',
  ],
  DATA_CORRECTION_REQUEST: ['DATA_CORRECTION_RECORD', 'REPORTS'],
};

const childSubMenus: Record<string, string[]> = {
  [SubMenuNameEnum.MATERIAL_REGISTER]: [
    SubMenuNameEnum.MATERIAL_ALL_REGISTER,
    SubMenuNameEnum.MATERIAL_REGISTER,
  ],
  [SubMenuNameEnum.NOTIFY_REQUIREMENTS]: [
    RequirementsEnum.MaterialsList,
    RequirementsEnum.NotifyRequirements,
    RequirementsEnum.historyRequirements,
    RequirementsEnum.ConsiderPurchase,
    RequirementsEnum.TrackStatus,
  ],
  [SubMenuNameEnum.EQUIPMENT_REGISTER]: [
    AssetRequirementsEnum.INFORMATION,
    AssetRequirementsEnum.EQUIPMENT_HISTORY,
    AssetRequirementsEnum.VEHICLE_USAGE_HISTORY,
    AssetRequirementsEnum.MAINTENANCE,
    AssetRequirementsEnum.FUEL_USAGE,
    AssetRequirementsEnum.TIRE_USAGE_STATS,
    AssetRequirementsEnum.BATTERY_USAGE_STATS,
    AssetRequirementsEnum.ACCIDENT_REPORTS,
    AssetRequirementsEnum.VEHICLE_INSPECTION,
    AssetRequirementsEnum.INSURANCE_AND_ACT,
    AssetRequirementsEnum.POLLUTION_CHECK,
  ],
  [SubMenuNameEnum.ASSET_RECORD_INSPECTION]: [
    BuildingRequirementsEnum.PROCUREMENT,
    BuildingRequirementsEnum.DONATION,
    BuildingRequirementsEnum.TRANSFER,
    BuildingRequirementsEnum.DISCOVERY,
    BuildingRequirementsEnum.PENDING_TRANSFER,
  ],
  [SubMenuNameEnum.EQUIPMENT_LOAN_RETURN]: [
    BorrowEnum.INTERNAL_EXTERNAL_BORROW,
    BorrowEnum.INTERAGENCY_BORROW,
    BorrowEnum.FARMER_GROUP_BORROW,
  ],
  [SubMenuNameEnum.RETURN_WAREHOUSE]: [
    SellReturnBuildingEnum.INVENTORY_LIST,
    SellReturnBuildingEnum.RETURN_LIST,
    SellReturnBuildingEnum.WITHDRAWAL_LIST,
    SellReturnBuildingEnum.DISPOSAL_LIST,
  ],
  [SubMenuNameEnum.BUILDING_REGISTRY]: [
    HistoryBuildingEnum.INFORMATION,
    HistoryBuildingEnum.ROOM_REGISTRY,
    HistoryBuildingEnum.BUILDING_HISTORY,
    HistoryBuildingEnum.MAINTENANCE,
  ],
  [SubMenuNameEnum.ASSET_RECORD]: [
    BuildingRequirementsEnum.PROCUREMENT,
    BuildingRequirementsEnum.DONATION,
    BuildingRequirementsEnum.TRANSFER,
    BuildingRequirementsEnum.DISCOVERY,
    BuildingRequirementsEnum.PENDING_TRANSFER,
  ],
  [SubMenuNameEnum.BORROW_RETURN_BUILDING]: [
    BuildingBorrowEnum.INTERNAL_EXTERNAL_BORROW,
    BuildingBorrowEnum.INTERAGENCY_BORROW,
    BuildingBorrowEnum.FARMER_GROUP_BORROW,
  ],
  [SubMenuNameEnum.BUILDING_WAREHOUSE]: [
    BuildingReturnEnum.INVENTORY_LIST,
    BuildingReturnEnum.RETURN_LIST,
    BuildingReturnEnum.WITHDRAWAL_LIST,
    BuildingReturnEnum.DISPOSAL_LIST,
  ],
};

const subMenusWithChildren = [
  'MATERIAL_REGISTER',
  'NOTIFY_REQUIREMENTS',
  'EQUIPMENT_REGISTER',
  'ASSET_RECORD_INSPECTION',
  'EQUIPMENT_LOAN_RETURN',
  'RETURN_WAREHOUSE',
  'BUILDING_REGISTRY',
  'ASSET_RECORD',
  'BORROW_RETURN_BUILDING',
  'BUILDING_WAREHOUSE',
];

export const buildMenuData = (): MainMenu[] => {
  return Object.entries(mainMenuMap).map(([mainKey, subKeys]) => ({
    main_menu_id: mainKey,
    main_menu_name: MainMenuNameEnum[mainKey as keyof typeof MainMenuNameEnum],
    menus: subKeys.map((subKey) => {
      const hasChildSubMenus = subMenusWithChildren.includes(subKey);
      return {
        sub_menu_id: subKey,
        sub_menu_name: SubMenuNameEnum[subKey as keyof typeof SubMenuNameEnum],
        is_view: false,
        ...(hasChildSubMenus && {
          child_sub_menus:
            expandedChildSubMenus[
              SubMenuNameEnum[subKey as keyof typeof SubMenuNameEnum]
            ] || [],
        }),
      };
    }),
  }));
};

let countIndex: number = 1;
const expandedChildSubMenus: Record<
  string,
  { child_sub_menu_id: number; child_sub_menu_name: string; is_view: boolean }[]
> = Object.entries(childSubMenus).reduce(
  (acc, [subMenuId, childIds], idx) => {
    acc[subMenuId] = childIds.map((childId, index) => ({
      child_sub_menu_id: countIndex++,
      child_sub_menu_name:
        RequirementsEnum[childId as keyof typeof RequirementsEnum] ||
        AssetRequirementsEnum[childId as keyof typeof AssetRequirementsEnum] ||
        childId,
      is_view: false,
    }));
    return acc;
  },
  {} as Record<
    string,
    {
      child_sub_menu_id: number;
      child_sub_menu_name: string;
      is_view: boolean;
    }[]
  >
);
